/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddDemoCaseRequest,
  BadRequestResponse,
  CompleteFtue200,
  ConfirmLogoUpload200,
  ConfirmLogoUploadBody,
  ConflictResponse,
  CreateOrganization200,
  CreateOrganizationBody,
  DeleteExternalApiKey200,
  DemoCase,
  DemoCaseExportAccepted,
  ForbiddenResponse,
  GenerateExternalApiKey200,
  GenerateExternalApiKeyBody,
  GetCaseTransferJobStatus200,
  GetDemoCaseReferenceReportDownloadUrl200,
  GetExternalApiKey200,
  GetLogoPresignedUrl200,
  GetLogoPresignedUrlBody,
  GetOrganization200,
  GetOrganizationSettings200,
  ImportDefaultCase202,
  ImportDefaultCaseBody,
  InternalServerErrorResponse,
  MarkSupportiveMaterialsPromptSeen200,
  MultipartPartRequest,
  MultipartPartUrl,
  MultipartUploadStarted,
  NotFoundResponse,
  Organization,
  ReferenceReport,
  ReferenceReportUploadCompleteRequest,
  ReferenceReportUploadStartRequest,
  UnauthorizedResponse,
  UpdateOrganization200,
  UpdateOrganizationBody,
  UpdateOrganizationSettings200,
  UpdateOrganizationSettingsBody
} from '../model';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get organization details
 */
export const getOrganization = (
    organizationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetOrganization200>(
      {url: `/organizations/${organizationId}`, method: 'GET', signal
    },
      options);
    }




export const getGetOrganizationQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}`
    ] as const;
    }


export const getGetOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof getOrganization>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({ signal }) => getOrganization(organizationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganization>>>
export type GetOrganizationQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get organization details
 */

export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update organization details
 */
export const updateOrganization = (
    organizationId: string,
    updateOrganizationBody: UpdateOrganizationBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UpdateOrganization200>(
      {url: `/organizations/${organizationId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationBody, signal
    },
      options);
    }




export const getUpdateOrganizationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganization>>, TError,{organizationId: string;data: UpdateOrganizationBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganization>>, TError,{organizationId: string;data: UpdateOrganizationBody}, TContext> => {

const mutationKey = ['updateOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganization>>, {organizationId: string;data: UpdateOrganizationBody}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  updateOrganization(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganization>>>
    export type UpdateOrganizationMutationBody = UpdateOrganizationBody
    export type UpdateOrganizationMutationError = unknown

    /**
 * @summary Update organization details
 */
export const useUpdateOrganization = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganization>>, TError,{organizationId: string;data: UpdateOrganizationBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganization>>,
        TError,
        {organizationId: string;data: UpdateOrganizationBody},
        TContext
      > => {
      return useMutation(getUpdateOrganizationMutationOptions(options), queryClient);
    }
    /**
 * @summary Get presigned URL for organization logo upload
 */
export const getLogoPresignedUrl = (
    organizationId: string,
    getLogoPresignedUrlBody: GetLogoPresignedUrlBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetLogoPresignedUrl200>(
      {url: `/organizations/${organizationId}/logo/presigned-url`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getLogoPresignedUrlBody, signal
    },
      options);
    }




export const getGetLogoPresignedUrlMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getLogoPresignedUrl>>, TError,{organizationId: string;data: GetLogoPresignedUrlBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getLogoPresignedUrl>>, TError,{organizationId: string;data: GetLogoPresignedUrlBody}, TContext> => {

const mutationKey = ['getLogoPresignedUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getLogoPresignedUrl>>, {organizationId: string;data: GetLogoPresignedUrlBody}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  getLogoPresignedUrl(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetLogoPresignedUrlMutationResult = NonNullable<Awaited<ReturnType<typeof getLogoPresignedUrl>>>
    export type GetLogoPresignedUrlMutationBody = GetLogoPresignedUrlBody
    export type GetLogoPresignedUrlMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Get presigned URL for organization logo upload
 */
export const useGetLogoPresignedUrl = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getLogoPresignedUrl>>, TError,{organizationId: string;data: GetLogoPresignedUrlBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getLogoPresignedUrl>>,
        TError,
        {organizationId: string;data: GetLogoPresignedUrlBody},
        TContext
      > => {
      return useMutation(getGetLogoPresignedUrlMutationOptions(options), queryClient);
    }
    /**
 * @summary Confirm logo upload and update organization
 */
export const confirmLogoUpload = (
    organizationId: string,
    confirmLogoUploadBody: ConfirmLogoUploadBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ConfirmLogoUpload200>(
      {url: `/organizations/${organizationId}/logo/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmLogoUploadBody, signal
    },
      options);
    }




export const getConfirmLogoUploadMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmLogoUpload>>, TError,{organizationId: string;data: ConfirmLogoUploadBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmLogoUpload>>, TError,{organizationId: string;data: ConfirmLogoUploadBody}, TContext> => {

const mutationKey = ['confirmLogoUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmLogoUpload>>, {organizationId: string;data: ConfirmLogoUploadBody}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  confirmLogoUpload(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmLogoUploadMutationResult = NonNullable<Awaited<ReturnType<typeof confirmLogoUpload>>>
    export type ConfirmLogoUploadMutationBody = ConfirmLogoUploadBody
    export type ConfirmLogoUploadMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Confirm logo upload and update organization
 */
export const useConfirmLogoUpload = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmLogoUpload>>, TError,{organizationId: string;data: ConfirmLogoUploadBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmLogoUpload>>,
        TError,
        {organizationId: string;data: ConfirmLogoUploadBody},
        TContext
      > => {
      return useMutation(getConfirmLogoUploadMutationOptions(options), queryClient);
    }
    /**
 * Loads seed from default-cases/{caseName}/{industry}/{version}/ using default-cases/config.json. Optional caseName, industry, and version default from config and organization type. When the server ENV is not `dev`, the caller must be SUPERADMIN or OWNER. When ENV is `dev`, that role check is skipped (organization access rules still apply).
 * @summary Import default demo case from S3 (default-cases config)
 */
export const importDefaultCase = (
    organizationId: string,
    importDefaultCaseBody: ImportDefaultCaseBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ImportDefaultCase202>(
      {url: `/organizations/${organizationId}/import-default-case`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importDefaultCaseBody, signal
    },
      options);
    }




export const getImportDefaultCaseMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importDefaultCase>>, TError,{organizationId: string;data: ImportDefaultCaseBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importDefaultCase>>, TError,{organizationId: string;data: ImportDefaultCaseBody}, TContext> => {

const mutationKey = ['importDefaultCase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importDefaultCase>>, {organizationId: string;data: ImportDefaultCaseBody}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  importDefaultCase(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportDefaultCaseMutationResult = NonNullable<Awaited<ReturnType<typeof importDefaultCase>>>
    export type ImportDefaultCaseMutationBody = ImportDefaultCaseBody
    export type ImportDefaultCaseMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Import default demo case from S3 (default-cases config)
 */
export const useImportDefaultCase = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importDefaultCase>>, TError,{organizationId: string;data: ImportDefaultCaseBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importDefaultCase>>,
        TError,
        {organizationId: string;data: ImportDefaultCaseBody},
        TContext
      > => {
      return useMutation(getImportDefaultCaseMutationOptions(options), queryClient);
    }
    /**
 * @summary Get organization settings (logo, font, line spacing, footnote)
 */
export const getOrganizationSettings = (
    organizationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetOrganizationSettings200>(
      {url: `/organizations/${organizationId}/settings`, method: 'GET', signal
    },
      options);
    }




export const getGetOrganizationSettingsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/settings`
    ] as const;
    }


export const getGetOrganizationSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationSettings>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationSettingsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSettings>>> = ({ signal }) => getOrganizationSettings(organizationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationSettings>>>
export type GetOrganizationSettingsQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetOrganizationSettings<TData = Awaited<ReturnType<typeof getOrganizationSettings>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationSettings<TData = Awaited<ReturnType<typeof getOrganizationSettings>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationSettings<TData = Awaited<ReturnType<typeof getOrganizationSettings>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get organization settings (logo, font, line spacing, footnote)
 */

export function useGetOrganizationSettings<TData = Awaited<ReturnType<typeof getOrganizationSettings>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationSettingsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update organization settings (logo, font, line spacing, footnote)
 */
export const updateOrganizationSettings = (
    organizationId: string,
    updateOrganizationSettingsBody: UpdateOrganizationSettingsBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UpdateOrganizationSettings200>(
      {url: `/organizations/${organizationId}/settings`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationSettingsBody, signal
    },
      options);
    }




export const getUpdateOrganizationSettingsMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationSettings>>, TError,{organizationId: string;data: UpdateOrganizationSettingsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationSettings>>, TError,{organizationId: string;data: UpdateOrganizationSettingsBody}, TContext> => {

const mutationKey = ['updateOrganizationSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganizationSettings>>, {organizationId: string;data: UpdateOrganizationSettingsBody}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  updateOrganizationSettings(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganizationSettings>>>
    export type UpdateOrganizationSettingsMutationBody = UpdateOrganizationSettingsBody
    export type UpdateOrganizationSettingsMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Update organization settings (logo, font, line spacing, footnote)
 */
export const useUpdateOrganizationSettings = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationSettings>>, TError,{organizationId: string;data: UpdateOrganizationSettingsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganizationSettings>>,
        TError,
        {organizationId: string;data: UpdateOrganizationSettingsBody},
        TContext
      > => {
      return useMutation(getUpdateOrganizationSettingsMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns the list of organizations for the current user
 */
export const listOrganizations = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Organization[]>(
      {url: `/organizations`, method: 'GET', signal
    },
      options);
    }




export const getListOrganizationsQueryKey = () => {
    return [
    `/organizations`
    ] as const;
    }


export const getListOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof listOrganizations>>, TError = UnauthorizedResponse | InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrganizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganizations>>> = ({ signal }) => listOrganizations(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrganizations>>>
export type ListOrganizationsQueryError = UnauthorizedResponse | InternalServerErrorResponse


export function useListOrganizations<TData = Awaited<ReturnType<typeof listOrganizations>>, TError = UnauthorizedResponse | InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizations<TData = Awaited<ReturnType<typeof listOrganizations>>, TError = UnauthorizedResponse | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizations<TData = Awaited<ReturnType<typeof listOrganizations>>, TError = UnauthorizedResponse | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the list of organizations for the current user
 */

export function useListOrganizations<TData = Awaited<ReturnType<typeof listOrganizations>>, TError = UnauthorizedResponse | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Creates a new organization, including:
 * - Creating an owner user in Cognito and database
 * - Creating a support user in Cognito and database
 * - Creating the organization in the database
 * - Creating standard document categories
 * @summary Creates a new organization with an owner and support
 */
export const createOrganization = (
    createOrganizationBody: CreateOrganizationBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CreateOrganization200>(
      {url: `/organizations/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganizationBody, signal
    },
      options);
    }




export const getCreateOrganizationMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: CreateOrganizationBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: CreateOrganizationBody}, TContext> => {

const mutationKey = ['createOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrganization>>, {data: CreateOrganizationBody}> = (props) => {
          const {data} = props ?? {};

          return  createOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof createOrganization>>>
    export type CreateOrganizationMutationBody = CreateOrganizationBody
    export type CreateOrganizationMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse

    /**
 * @summary Creates a new organization with an owner and support
 */
export const useCreateOrganization = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: CreateOrganizationBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrganization>>,
        TError,
        {data: CreateOrganizationBody},
        TContext
      > => {
      return useMutation(getCreateOrganizationMutationOptions(options), queryClient);
    }
    /**
 * Get all active API keys for an organization
 * @summary Get organization API keys
 */
export const getExternalApiKey = (
    organizationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetExternalApiKey200>(
      {url: `/organizations/${organizationId}/external-api/key`, method: 'GET', signal
    },
      options);
    }




export const getGetExternalApiKeyQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/external-api/key`
    ] as const;
    }


export const getGetExternalApiKeyQueryOptions = <TData = Awaited<ReturnType<typeof getExternalApiKey>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalApiKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExternalApiKeyQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExternalApiKey>>> = ({ signal }) => getExternalApiKey(organizationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExternalApiKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExternalApiKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getExternalApiKey>>>
export type GetExternalApiKeyQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetExternalApiKey<TData = Awaited<ReturnType<typeof getExternalApiKey>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalApiKey>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExternalApiKey>>,
          TError,
          Awaited<ReturnType<typeof getExternalApiKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalApiKey<TData = Awaited<ReturnType<typeof getExternalApiKey>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalApiKey>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExternalApiKey>>,
          TError,
          Awaited<ReturnType<typeof getExternalApiKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalApiKey<TData = Awaited<ReturnType<typeof getExternalApiKey>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalApiKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get organization API keys
 */

export function useGetExternalApiKey<TData = Awaited<ReturnType<typeof getExternalApiKey>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalApiKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExternalApiKeyQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Generate a new API key for an organization. The full API key is only returned once upon creation.
 * @summary Generate a new API key
 */
export const generateExternalApiKey = (
    organizationId: string,
    generateExternalApiKeyBody: GenerateExternalApiKeyBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GenerateExternalApiKey200>(
      {url: `/organizations/${organizationId}/external-api/key`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateExternalApiKeyBody, signal
    },
      options);
    }




export const getGenerateExternalApiKeyMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateExternalApiKey>>, TError,{organizationId: string;data: GenerateExternalApiKeyBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateExternalApiKey>>, TError,{organizationId: string;data: GenerateExternalApiKeyBody}, TContext> => {

const mutationKey = ['generateExternalApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateExternalApiKey>>, {organizationId: string;data: GenerateExternalApiKeyBody}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  generateExternalApiKey(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateExternalApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof generateExternalApiKey>>>
    export type GenerateExternalApiKeyMutationBody = GenerateExternalApiKeyBody
    export type GenerateExternalApiKeyMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Generate a new API key
 */
export const useGenerateExternalApiKey = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateExternalApiKey>>, TError,{organizationId: string;data: GenerateExternalApiKeyBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateExternalApiKey>>,
        TError,
        {organizationId: string;data: GenerateExternalApiKeyBody},
        TContext
      > => {
      return useMutation(getGenerateExternalApiKeyMutationOptions(options), queryClient);
    }
    /**
 * Soft delete an API key by setting it as inactive and recording deletion timestamp. The API key cannot be used after deletion.
 * @summary Delete organization API key
 */
export const deleteExternalApiKey = (
    organizationId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeleteExternalApiKey200>(
      {url: `/organizations/${organizationId}/external-api/key/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteExternalApiKeyMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExternalApiKey>>, TError,{organizationId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteExternalApiKey>>, TError,{organizationId: string;id: string}, TContext> => {

const mutationKey = ['deleteExternalApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteExternalApiKey>>, {organizationId: string;id: string}> = (props) => {
          const {organizationId,id} = props ?? {};

          return  deleteExternalApiKey(organizationId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteExternalApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteExternalApiKey>>>

    export type DeleteExternalApiKeyMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Delete organization API key
 */
export const useDeleteExternalApiKey = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExternalApiKey>>, TError,{organizationId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteExternalApiKey>>,
        TError,
        {organizationId: string;id: string},
        TContext
      > => {
      return useMutation(getDeleteExternalApiKeyMutationOptions(options), queryClient);
    }
    /**
 * Updates the user's hasCompletedFtue flag to true and sets ftueCompletedAt timestamp
 * @summary Mark the current user's FTUE as complete
 */
export const completeFtue = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CompleteFtue200>(
      {url: `/organizations/complete-ftue`, method: 'PATCH', signal
    },
      options);
    }




export const getCompleteFtueMutationOptions = <TError = UnauthorizedResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeFtue>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeFtue>>, TError,void, TContext> => {

const mutationKey = ['completeFtue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeFtue>>, void> = () => {


          return  completeFtue(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteFtueMutationResult = NonNullable<Awaited<ReturnType<typeof completeFtue>>>

    export type CompleteFtueMutationError = UnauthorizedResponse | InternalServerErrorResponse

    /**
 * @summary Mark the current user's FTUE as complete
 */
export const useCompleteFtue = <TError = UnauthorizedResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeFtue>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeFtue>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCompleteFtueMutationOptions(options), queryClient);
    }
    /**
 * Updates the user's hasSeenSupportiveMaterialsPrompt flag to true and sets supportiveMaterialsPromptSeenAt timestamp
 * @summary Mark the supportive-materials prompt as seen for the current user
 */
export const markSupportiveMaterialsPromptSeen = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MarkSupportiveMaterialsPromptSeen200>(
      {url: `/organizations/supportive-materials-prompt-seen`, method: 'PATCH', signal
    },
      options);
    }




export const getMarkSupportiveMaterialsPromptSeenMutationOptions = <TError = UnauthorizedResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markSupportiveMaterialsPromptSeen>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markSupportiveMaterialsPromptSeen>>, TError,void, TContext> => {

const mutationKey = ['markSupportiveMaterialsPromptSeen'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markSupportiveMaterialsPromptSeen>>, void> = () => {


          return  markSupportiveMaterialsPromptSeen(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkSupportiveMaterialsPromptSeenMutationResult = NonNullable<Awaited<ReturnType<typeof markSupportiveMaterialsPromptSeen>>>

    export type MarkSupportiveMaterialsPromptSeenMutationError = UnauthorizedResponse | InternalServerErrorResponse

    /**
 * @summary Mark the supportive-materials prompt as seen for the current user
 */
export const useMarkSupportiveMaterialsPromptSeen = <TError = UnauthorizedResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markSupportiveMaterialsPromptSeen>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markSupportiveMaterialsPromptSeen>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMarkSupportiveMaterialsPromptSeenMutationOptions(options), queryClient);
    }
    /**
 * @summary Get demo-case export/import job status
 */
export const getCaseTransferJobStatus = (
    organizationId: string,
    jobId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetCaseTransferJobStatus200>(
      {url: `/organizations/${organizationId}/case-transfer-jobs/${jobId}`, method: 'GET', signal
    },
      options);
    }




export const getGetCaseTransferJobStatusQueryKey = (organizationId: string,
    jobId: string,) => {
    return [
    `/organizations/${organizationId}/case-transfer-jobs/${jobId}`
    ] as const;
    }


export const getGetCaseTransferJobStatusQueryOptions = <TData = Awaited<ReturnType<typeof getCaseTransferJobStatus>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseTransferJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCaseTransferJobStatusQueryKey(organizationId,jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCaseTransferJobStatus>>> = ({ signal }) => getCaseTransferJobStatus(organizationId,jobId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCaseTransferJobStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCaseTransferJobStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getCaseTransferJobStatus>>>
export type GetCaseTransferJobStatusQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetCaseTransferJobStatus<TData = Awaited<ReturnType<typeof getCaseTransferJobStatus>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseTransferJobStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCaseTransferJobStatus>>,
          TError,
          Awaited<ReturnType<typeof getCaseTransferJobStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCaseTransferJobStatus<TData = Awaited<ReturnType<typeof getCaseTransferJobStatus>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseTransferJobStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCaseTransferJobStatus>>,
          TError,
          Awaited<ReturnType<typeof getCaseTransferJobStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCaseTransferJobStatus<TData = Awaited<ReturnType<typeof getCaseTransferJobStatus>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseTransferJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get demo-case export/import job status
 */

export function useGetCaseTransferJobStatus<TData = Awaited<ReturnType<typeof getCaseTransferJobStatus>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseTransferJobStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCaseTransferJobStatusQueryOptions(organizationId,jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List current demo cases and reference reports
 */
export const listDemoCases = (
    organizationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DemoCase[]>(
      {url: `/organizations/${organizationId}/demo-cases`, method: 'GET', signal
    },
      options);
    }




export const getListDemoCasesQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/demo-cases`
    ] as const;
    }


export const getListDemoCasesQueryOptions = <TData = Awaited<ReturnType<typeof listDemoCases>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDemoCases>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDemoCasesQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDemoCases>>> = ({ signal }) => listDemoCases(organizationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDemoCases>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDemoCasesQueryResult = NonNullable<Awaited<ReturnType<typeof listDemoCases>>>
export type ListDemoCasesQueryError = UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse


export function useListDemoCases<TData = Awaited<ReturnType<typeof listDemoCases>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDemoCases>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDemoCases>>,
          TError,
          Awaited<ReturnType<typeof listDemoCases>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDemoCases<TData = Awaited<ReturnType<typeof listDemoCases>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDemoCases>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDemoCases>>,
          TError,
          Awaited<ReturnType<typeof listDemoCases>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDemoCases<TData = Awaited<ReturnType<typeof listDemoCases>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDemoCases>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List current demo cases and reference reports
 */

export function useListDemoCases<TData = Awaited<ReturnType<typeof listDemoCases>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDemoCases>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDemoCasesQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Development-only endpoint for adding a demo case export.
 * @summary Add a demo case export
 */
export const addDemoCase = (
    organizationId: string,
    addDemoCaseRequest: AddDemoCaseRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DemoCaseExportAccepted>(
      {url: `/organizations/${organizationId}/demo-cases`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addDemoCaseRequest, signal
    },
      options);
    }




export const getAddDemoCaseMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDemoCase>>, TError,{organizationId: string;data: AddDemoCaseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addDemoCase>>, TError,{organizationId: string;data: AddDemoCaseRequest}, TContext> => {

const mutationKey = ['addDemoCase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addDemoCase>>, {organizationId: string;data: AddDemoCaseRequest}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  addDemoCase(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddDemoCaseMutationResult = NonNullable<Awaited<ReturnType<typeof addDemoCase>>>
    export type AddDemoCaseMutationBody = AddDemoCaseRequest
    export type AddDemoCaseMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Add a demo case export
 */
export const useAddDemoCase = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDemoCase>>, TError,{organizationId: string;data: AddDemoCaseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addDemoCase>>,
        TError,
        {organizationId: string;data: AddDemoCaseRequest},
        TContext
      > => {
      return useMutation(getAddDemoCaseMutationOptions(options), queryClient);
    }
    /**
 * Development-only endpoint for removing a demo case from the config.
 * @summary Remove a demo case from the config
 */
export const removeDemoCase = (
    organizationId: string,
    demoCaseId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/organizations/${organizationId}/demo-cases/${demoCaseId}`, method: 'DELETE', signal
    },
      options);
    }




export const getRemoveDemoCaseMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeDemoCase>>, TError,{organizationId: string;demoCaseId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeDemoCase>>, TError,{organizationId: string;demoCaseId: string}, TContext> => {

const mutationKey = ['removeDemoCase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeDemoCase>>, {organizationId: string;demoCaseId: string}> = (props) => {
          const {organizationId,demoCaseId} = props ?? {};

          return  removeDemoCase(organizationId,demoCaseId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveDemoCaseMutationResult = NonNullable<Awaited<ReturnType<typeof removeDemoCase>>>

    export type RemoveDemoCaseMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Remove a demo case from the config
 */
export const useRemoveDemoCase = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeDemoCase>>, TError,{organizationId: string;demoCaseId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeDemoCase>>,
        TError,
        {organizationId: string;demoCaseId: string},
        TContext
      > => {
      return useMutation(getRemoveDemoCaseMutationOptions(options), queryClient);
    }
    /**
 * Development-only endpoint for initiating a demo-case reference report upload.
 * @summary Initiate a demo-case reference report multipart upload
 */
export const startDemoCaseReferenceReportUpload = (
    organizationId: string,
    demoCaseId: string,
    uploadId: string,
    referenceReportUploadStartRequest: ReferenceReportUploadStartRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MultipartUploadStarted>(
      {url: `/organizations/${organizationId}/demo-cases/${demoCaseId}/reference-reports/upload/${uploadId}/start`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: referenceReportUploadStartRequest, signal
    },
      options);
    }




export const getStartDemoCaseReferenceReportUploadMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startDemoCaseReferenceReportUpload>>, TError,{organizationId: string;demoCaseId: string;uploadId: string;data: ReferenceReportUploadStartRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startDemoCaseReferenceReportUpload>>, TError,{organizationId: string;demoCaseId: string;uploadId: string;data: ReferenceReportUploadStartRequest}, TContext> => {

const mutationKey = ['startDemoCaseReferenceReportUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startDemoCaseReferenceReportUpload>>, {organizationId: string;demoCaseId: string;uploadId: string;data: ReferenceReportUploadStartRequest}> = (props) => {
          const {organizationId,demoCaseId,uploadId,data} = props ?? {};

          return  startDemoCaseReferenceReportUpload(organizationId,demoCaseId,uploadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartDemoCaseReferenceReportUploadMutationResult = NonNullable<Awaited<ReturnType<typeof startDemoCaseReferenceReportUpload>>>
    export type StartDemoCaseReferenceReportUploadMutationBody = ReferenceReportUploadStartRequest
    export type StartDemoCaseReferenceReportUploadMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Initiate a demo-case reference report multipart upload
 */
export const useStartDemoCaseReferenceReportUpload = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startDemoCaseReferenceReportUpload>>, TError,{organizationId: string;demoCaseId: string;uploadId: string;data: ReferenceReportUploadStartRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startDemoCaseReferenceReportUpload>>,
        TError,
        {organizationId: string;demoCaseId: string;uploadId: string;data: ReferenceReportUploadStartRequest},
        TContext
      > => {
      return useMutation(getStartDemoCaseReferenceReportUploadMutationOptions(options), queryClient);
    }
    /**
 * Development-only endpoint for getting a demo-case reference report part URL.
 * @summary Get a presigned reference report part URL
 */
export const getDemoCaseReferenceReportPartUrl = (
    organizationId: string,
    demoCaseId: string,
    uploadId: string,
    multipartPartRequest: MultipartPartRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MultipartPartUrl>(
      {url: `/organizations/${organizationId}/demo-cases/${demoCaseId}/reference-reports/upload/${uploadId}/part-url`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: multipartPartRequest, signal
    },
      options);
    }




export const getGetDemoCaseReferenceReportPartUrlMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDemoCaseReferenceReportPartUrl>>, TError,{organizationId: string;demoCaseId: string;uploadId: string;data: MultipartPartRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getDemoCaseReferenceReportPartUrl>>, TError,{organizationId: string;demoCaseId: string;uploadId: string;data: MultipartPartRequest}, TContext> => {

const mutationKey = ['getDemoCaseReferenceReportPartUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getDemoCaseReferenceReportPartUrl>>, {organizationId: string;demoCaseId: string;uploadId: string;data: MultipartPartRequest}> = (props) => {
          const {organizationId,demoCaseId,uploadId,data} = props ?? {};

          return  getDemoCaseReferenceReportPartUrl(organizationId,demoCaseId,uploadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetDemoCaseReferenceReportPartUrlMutationResult = NonNullable<Awaited<ReturnType<typeof getDemoCaseReferenceReportPartUrl>>>
    export type GetDemoCaseReferenceReportPartUrlMutationBody = MultipartPartRequest
    export type GetDemoCaseReferenceReportPartUrlMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Get a presigned reference report part URL
 */
export const useGetDemoCaseReferenceReportPartUrl = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDemoCaseReferenceReportPartUrl>>, TError,{organizationId: string;demoCaseId: string;uploadId: string;data: MultipartPartRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getDemoCaseReferenceReportPartUrl>>,
        TError,
        {organizationId: string;demoCaseId: string;uploadId: string;data: MultipartPartRequest},
        TContext
      > => {
      return useMutation(getGetDemoCaseReferenceReportPartUrlMutationOptions(options), queryClient);
    }
    /**
 * Development-only endpoint for completing a demo-case reference report upload.
 * @summary Complete a demo-case reference report multipart upload
 */
export const completeDemoCaseReferenceReportUpload = (
    organizationId: string,
    demoCaseId: string,
    uploadId: string,
    referenceReportUploadCompleteRequest: ReferenceReportUploadCompleteRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ReferenceReport>(
      {url: `/organizations/${organizationId}/demo-cases/${demoCaseId}/reference-reports/upload/${uploadId}/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: referenceReportUploadCompleteRequest, signal
    },
      options);
    }




export const getCompleteDemoCaseReferenceReportUploadMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeDemoCaseReferenceReportUpload>>, TError,{organizationId: string;demoCaseId: string;uploadId: string;data: ReferenceReportUploadCompleteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeDemoCaseReferenceReportUpload>>, TError,{organizationId: string;demoCaseId: string;uploadId: string;data: ReferenceReportUploadCompleteRequest}, TContext> => {

const mutationKey = ['completeDemoCaseReferenceReportUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeDemoCaseReferenceReportUpload>>, {organizationId: string;demoCaseId: string;uploadId: string;data: ReferenceReportUploadCompleteRequest}> = (props) => {
          const {organizationId,demoCaseId,uploadId,data} = props ?? {};

          return  completeDemoCaseReferenceReportUpload(organizationId,demoCaseId,uploadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteDemoCaseReferenceReportUploadMutationResult = NonNullable<Awaited<ReturnType<typeof completeDemoCaseReferenceReportUpload>>>
    export type CompleteDemoCaseReferenceReportUploadMutationBody = ReferenceReportUploadCompleteRequest
    export type CompleteDemoCaseReferenceReportUploadMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Complete a demo-case reference report multipart upload
 */
export const useCompleteDemoCaseReferenceReportUpload = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeDemoCaseReferenceReportUpload>>, TError,{organizationId: string;demoCaseId: string;uploadId: string;data: ReferenceReportUploadCompleteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeDemoCaseReferenceReportUpload>>,
        TError,
        {organizationId: string;demoCaseId: string;uploadId: string;data: ReferenceReportUploadCompleteRequest},
        TContext
      > => {
      return useMutation(getCompleteDemoCaseReferenceReportUploadMutationOptions(options), queryClient);
    }
    /**
 * Development-only endpoint for getting a demo-case reference report download URL.
 * @summary Get a demo-case reference report download URL
 */
export const getDemoCaseReferenceReportDownloadUrl = (
    organizationId: string,
    demoCaseId: string,
    reportId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetDemoCaseReferenceReportDownloadUrl200>(
      {url: `/organizations/${organizationId}/demo-cases/${demoCaseId}/reference-reports/${reportId}/download`, method: 'GET', signal
    },
      options);
    }




export const getGetDemoCaseReferenceReportDownloadUrlQueryKey = (organizationId: string,
    demoCaseId: string,
    reportId: string,) => {
    return [
    `/organizations/${organizationId}/demo-cases/${demoCaseId}/reference-reports/${reportId}/download`
    ] as const;
    }


export const getGetDemoCaseReferenceReportDownloadUrlQueryOptions = <TData = Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    demoCaseId: string,
    reportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDemoCaseReferenceReportDownloadUrlQueryKey(organizationId,demoCaseId,reportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>> = ({ signal }) => getDemoCaseReferenceReportDownloadUrl(organizationId,demoCaseId,reportId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && demoCaseId !== null && demoCaseId !== undefined && reportId !== null && reportId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDemoCaseReferenceReportDownloadUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>>
export type GetDemoCaseReferenceReportDownloadUrlQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetDemoCaseReferenceReportDownloadUrl<TData = Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    demoCaseId: string,
    reportId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDemoCaseReferenceReportDownloadUrl<TData = Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    demoCaseId: string,
    reportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDemoCaseReferenceReportDownloadUrl<TData = Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    demoCaseId: string,
    reportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a demo-case reference report download URL
 */

export function useGetDemoCaseReferenceReportDownloadUrl<TData = Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    demoCaseId: string,
    reportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDemoCaseReferenceReportDownloadUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDemoCaseReferenceReportDownloadUrlQueryOptions(organizationId,demoCaseId,reportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Development-only endpoint for deleting a demo-case reference report.
 * @summary Delete a demo-case reference report
 */
export const deleteDemoCaseReferenceReport = (
    organizationId: string,
    demoCaseId: string,
    reportId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/organizations/${organizationId}/demo-cases/${demoCaseId}/reference-reports/${reportId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteDemoCaseReferenceReportMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDemoCaseReferenceReport>>, TError,{organizationId: string;demoCaseId: string;reportId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDemoCaseReferenceReport>>, TError,{organizationId: string;demoCaseId: string;reportId: string}, TContext> => {

const mutationKey = ['deleteDemoCaseReferenceReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDemoCaseReferenceReport>>, {organizationId: string;demoCaseId: string;reportId: string}> = (props) => {
          const {organizationId,demoCaseId,reportId} = props ?? {};

          return  deleteDemoCaseReferenceReport(organizationId,demoCaseId,reportId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDemoCaseReferenceReportMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDemoCaseReferenceReport>>>

    export type DeleteDemoCaseReferenceReportMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Delete a demo-case reference report
 */
export const useDeleteDemoCaseReferenceReport = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDemoCaseReferenceReport>>, TError,{organizationId: string;demoCaseId: string;reportId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDemoCaseReferenceReport>>,
        TError,
        {organizationId: string;demoCaseId: string;reportId: string},
        TContext
      > => {
      return useMutation(getDeleteDemoCaseReferenceReportMutationOptions(options), queryClient);
    }
